import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';
import Chart from 'chart.js/auto';
import { calculators } from '../../common/js/calculator';
import ppfCalculator from '../ppfCalculator/ppfCalculator';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { paddingLeftPlugin } from '../ppfCalculator/customChartPlugin';
export const powerOfCompoundInterest = {
    variables:{
        powerOfCompoundInterestWrapper: '.power__of__ci--wrapper',
        powerOfCompoundAmountTextPlaceholder:'{amount}',
        powerOfCompoundInterestAmountInput:'.power__of__ci--rupee',
        powerOfCompoundInterestAmountText:'.power__of__ci--amount',
        powerOfCompoundInterestNextCTA:'.power__of__ci__cta--next',
        powerOfCompoundInterestPrevCTA:'.power__of__ci__cta--back',
        powerOfCompoundInterestSubmit:'.power__of__ci--form',
        powerOfCompoundInterestRequiredInput:'.power__of__ci--input',
        powerOfCompoundInterestYearsPlaceholder:'{years}',
        powerOfCompoundInterestDurationPlaceholder:'{durationYear}',
        powerOfCompoundInterestROIPlaceholder:'{rateOfInterest}',
        powerOfCompoundInterestYearsInput:'.power__of__ci__invest',
        powerOfCompoundInterestDurationInput:'.power__of__ci__invested',
        powerOfCompoundInterestROIInput:'.power__of__ci__roi',
        powerOfCompoundInterestInvestmentText:'.power__of__ci__investment--text',
        powerOfCompoundInterestInputMinLengthAttr:'data-min-length',
        powerOfCompoundInterestInputMaxLengthAttr: 'data-max-length',
        powerOfCompoundInterestNameInput:'.power__of__ci__name',
        powerOfCompoundInterestMobileInput:'.power__of__ci__mobile',
        powerOfCompoundInterestNameText:'.power__of__ci__name--text',
        powerOfCompoundInterestMobileText:'.power__of__ci__mobile--text',
        powerOfCompoundInterestNamePlaceholder:'{customerName}',
        powerOfCompoundInterestMobilePlaceholder:'{phoneNumber}',
        powerOfCompoundInterestNameMsgPlaceholder:'{name}',
        powerOfCompoundInterestNameMsg:'.power__of__ci__maturity--msg',
        powerOfCompoundInterestSubheading:'.power__of__ci__maturity--subheading',
        powerOfCompoundInterestMaturity:'.power__of__ci__maturity--amount',
        powerOfCompoundInterestTotalYearsPlaceholder:'{years}',
        powerOfCompoundInterestRoiPlaceholder:'{roi}',
        powerOfCompoundInterestMaturityPlaceholder:'{pciMaturityAmount}',
        powerOfCompoundInterestReCalculateBtn:'.power__of__ci--reset',
        pciData:[],
        pciMaturity:0,
        pciLabels:[],
        pciAmount:[],
        pciInterest:[],
        pciChartInstance:null,
        FONT_SIZE:12,
        userName: null,
        mobileNo: null

    },
    methods:{
        initializePCI:function(){
            const {powerOfCompoundInterestWrapper} = powerOfCompoundInterest.variables;
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $self = this
            $(powerOfCompoundInterestWrapper).each(function(){
                $self.replaceAmountInput(this);
                $self.nextPrevHandler(this);    
                $self.replaceInvestmentDetailsInput(this); 
                $self.replacePersonalInput(this);
                $self.requiredValidationOnInput(this);
                $self.reCalculate(this);
                $self.setChartFontSize();
            });
            /* eslint-disable @typescript-eslint/no-this-alias */
        },
        replaceAmountInput:function (el){
            const $el = $(el);
            const {powerOfCompoundAmountTextPlaceholder,powerOfCompoundInterestAmountInput,powerOfCompoundInterestAmountText} = powerOfCompoundInterest.variables;
            const investmentInput = $el.find(powerOfCompoundInterestAmountInput).parent().removeClass('d-none').detach();
            const amountText = $el.find(powerOfCompoundInterestAmountText);
            if(amountText.length > 0){
                const replacedTextEl = amountText.html().replace(powerOfCompoundAmountTextPlaceholder, investmentInput.prop('outerHTML'))
                amountText.html(replacedTextEl);
                calculators.methods.currencyFormat();
            }
            $el.find('input').on(CONSTANT.eventsListners.INPUT,(e)=>{
                e.target.style.width = e.target.value.length + "ch";
            })
        },
        replaceInvestmentDetailsInput:function(el){
            const $el = $(el);
            const {powerOfCompoundInterestYearsPlaceholder,powerOfCompoundInterestDurationPlaceholder,powerOfCompoundInterestROIPlaceholder,powerOfCompoundInterestYearsInput,powerOfCompoundInterestDurationInput,powerOfCompoundInterestROIInput,powerOfCompoundInterestInvestmentText} = powerOfCompoundInterest.variables;
            const investmentInput = $el.find(powerOfCompoundInterestYearsInput).removeClass('d-none').detach();
            const investedInput = $el.find(powerOfCompoundInterestDurationInput).removeClass('d-none').detach();
            const roiInput = $el.find(powerOfCompoundInterestROIInput).removeClass('d-none').detach();
            const investmentText = $el.find(powerOfCompoundInterestInvestmentText);
            if(investmentText.length > 0){
                const replacedTextEl = investmentText.html().replace(powerOfCompoundInterestYearsPlaceholder, investmentInput.prop('outerHTML'))
                                   .replace(powerOfCompoundInterestDurationPlaceholder, investedInput.prop('outerHTML'))
                                   .replace(powerOfCompoundInterestROIPlaceholder, roiInput.prop('outerHTML'));
                                investmentText.html(replacedTextEl);
            }
            calculators.methods.onlyNumbers();
        },
        replacePersonalInput:function(el){
            const $el = $(el);
            const {powerOfCompoundInterestNameInput, powerOfCompoundInterestMobileInput, powerOfCompoundInterestNamePlaceholder, powerOfCompoundInterestMobilePlaceholder,powerOfCompoundInterestMobileText,powerOfCompoundInterestNameText} = powerOfCompoundInterest.variables;
            const nameText = $el.find(powerOfCompoundInterestNameText);
            const mobileText = $el.find(powerOfCompoundInterestMobileText);
            const nameInput = $el.find(powerOfCompoundInterestNameInput).removeClass('d-none').detach();
            const mobileInput = $el.find(powerOfCompoundInterestMobileInput).removeClass('d-none').detach();
            if(nameText.length > 0 && mobileText.length > 0){
                const replacedNameTextEl = nameText.html().replace(powerOfCompoundInterestNamePlaceholder, nameInput.prop('outerHTML'));
                const replaceMobileTextEl = mobileText.html().replace(powerOfCompoundInterestMobilePlaceholder, mobileInput.prop('outerHTML'));
                nameText.html(replacedNameTextEl);
                mobileText.html(replaceMobileTextEl);
            }
            calculators.methods.onlyNumbers();
            calculators.methods.onlyText();
        },
        calculatePCI:function (p,freq,i,invest,stay) {
            var principal = parseFloat(p);
            var investementfrequency1 = ["monthly","yearly","2","half-yearly","quarterly"];
            var investementfrequency = investementfrequency1.indexOf(freq);
            var interestRate = parseFloat(i);
            var interestRate1 = interestRate;
            interestRate = interestRate / 100;
            var timesCompounded1 = ["0","Yearly","Half-Yearly","3","Quarterly",5,6,7,8,9,10,11,"Monthly"];
            var timesCompounded = parseFloat(timesCompounded1.indexOf("Yearly"));
            var termOfLoan = parseFloat(invest);
            var termOfLoan1 = parseFloat(stay);
            var principal1 = 0;
            
            if(investementfrequency == 0)
            {
                var months = (termOfLoan * 12);
        
                var interestRate2 = ((((1+(interestRate1/100))**(1/12)-1)*100) * 12) / 100;
                
                for (let i = 1; i <= months; i++) {
                    principal1 += principal;
                        principal1 += principal1 * (interestRate2 / 12);
                  }
        
                  if(termOfLoan1 > termOfLoan)
                  {
                      var years = termOfLoan1 - termOfLoan;
        
                        for (let i = 1; i <= years; i++) {
                            principal1 += principal1 * (interestRate / 1);
                        }
        
                        principal = (principal * months);
                        amount = principal1.toFixed(0);
                  }
                  else
                  {
                    principal = (principal * months);
                    amount = principal1.toFixed(0);
                  }
        
                  
            }
            else if(investementfrequency == 1)
            {
        
                var years = termOfLoan;
        
                for (let i = 1; i <= years; i++) {
                    principal1 += principal;
                    principal1 += principal1 * (interestRate / 1);
                  }
        
                  if(termOfLoan1 > termOfLoan)
                  {
                      var years = termOfLoan1 - termOfLoan;
        
                        for (let i = 1; i <= years; i++) {
                            principal1 += principal1 * (interestRate / 1);
                        }
        
                        principal = (principal * termOfLoan);
                        amount = principal1.toFixed(0);
                  }
                  else
                  {
                        principal = (principal * years);
                        amount = principal1.toFixed(0);
                  }
            }
            else if(investementfrequency == 2)
            {
                principal = principal;
                var a = interestRate / timesCompounded;
                var b = 1 + a;
                var c = timesCompounded * termOfLoan;
                var d = Math.pow(b, c);
                var amount = (principal * d).toFixed(0);
            }
            else if(investementfrequency == 3)
            {
        
                var years = termOfLoan * 2;
                var interestRate2 = ((((1+(interestRate1/100))**(1/2)-1)*100) * 2) / 100;
                for (let i = 1; i <= years; i++) {
                    principal1 += (principal);
                        principal1 += principal1 * (interestRate2 / 2);
                  }
        
                  if(termOfLoan1 > termOfLoan)
                  {
                      var years = termOfLoan1 - termOfLoan;
        
                        for (let i = 1; i <= years; i++) {
                            principal1 += principal1 * (interestRate / 1);
                        }
        
                        principal = (principal * termOfLoan * 2);
                        amount = principal1.toFixed(0);
                  }
                  else
                  {
                        principal = (principal * years);
                        amount = principal1.toFixed(0);
                  }
            }
            else if(investementfrequency == 4)
            {
        
                var years = termOfLoan * 4;
                var interestRate2 = ((((1+(interestRate1/100))**(1/4)-1)*100) * 4) / 100;
                for (let i = 1; i <= years; i++) {
                    principal1 += (principal);
                        principal1 += principal1 * (interestRate2 / 4);
                    
                  }
        
                  if(termOfLoan1 > termOfLoan)
                  {
                      var years = termOfLoan1 - termOfLoan;
        
                        for (let i = 1; i <= years; i++) {
                            principal1 += principal1 * (interestRate / 1);
                        }
        
                        principal = (principal * termOfLoan * 4);
                        amount = principal1.toFixed(0);
                  }
                  else
                  {
                        principal = (principal * years);
                        amount = principal1.toFixed(0);
                  }
            }
        
            
            if(termOfLoan1 > termOfLoan)
            {
            }    
            else
            {
            }
            if(isNaN(amount))
            {
                amount = 0;
            }
            if(isNaN(principal))
            {
                principal = 0;
            }
            return amount
          },
        getChartData:function(p,freq,i,invest,stay) {
            const {variables} = powerOfCompoundInterest;
            variables.pciAmount=[];
            variables.pciInterest=[];
            variables.pciLabels=[];
            var investementfrequency1 = ["monthly","yearly","half-yearly","3","quarterly"];
            var investementfrequency = parseInt(investementfrequency1.indexOf(freq));
            var n3;
                if(investementfrequency == 0)
                {
                    n3 = 12;
                }
                else if(investementfrequency == 1)
                {
                    n3 = 1;
                }
                else if(investementfrequency == 2)
                {
                    n3 = 2;
                }
                else if(investementfrequency == 3)
                {
                    n3 = 2;
                }
                else if(investementfrequency == 4)
                {
                    n3 = 3;
                }
                var p1;
                var p2;
                if(n3 == 0)
                {
                    p1 = parseFloat(p);
                    p2 = 0;
                }
                else if(n3 == 1)
                {
                    p1 = parseFloat(p);
                    p2 = parseFloat(p);
                }
                else if(n3 == 12)
                {
                    p1 = 0;
                    p2 = parseFloat(p);
                }
                else if(n3 == 2)
                {
                    p1 = 0;
                    p2 = parseFloat(p);
                }
                else if(n3 == 3)
                {
                    p1 = 0;
                    p2 = parseFloat(p);
                }
    
                var P = p1,
                //P = parseFloat(initial_deposit.value), // Principal
                r = parseFloat(i / 100), // Annual Interest Rate
                c = p2, // Contribution Amount
                timesCompounded1 = ["0","Yearly","Half Yearly","3","Quarterly",5,6,7,8,9,10,11,"Monthly"];
                var n = parseInt(timesCompounded1.indexOf("Yearly")), // Compound Period
                n2 = n3, // Contribution Period
                t = parseInt(invest), // Investment Time Span
                t1 = parseInt(stay),
                currentYear = (new Date()).getFullYear();
                var year1 = t;
                if(t1 > t && n3 != 0)
                {
                    t = t1;
                }
            for (var year = currentYear; year < currentYear + t; year++) {
                variables.pciLabels.push(year);
            }
            t = year1;

                if(n3 == 0)
                {
                    var principal3 = P;
                    for (var i = 1; i <= t; i++) {
                        
                        var    interest = 0,
                            balance = principal3;
                            if (r) {
                            
                                var x = Math.pow(1 + r / n, n * i),
                                    compound_interest = P * x,
                                    contribution_interest = c * (x - 1) / (r / n2);
                                    
                                
                                interest = (compound_interest + contribution_interest - principal3).toFixed(0);
                                balance = (compound_interest + contribution_interest).toFixed(0);
                            }
                            variables.pciAmount.push(principal3);
                            variables.pciInterest.push(principal3+interest);   
                        }  
                }
                else if(n3 == 1)
                {
                    
                    if(t1 > t)
                    {
                        //t = t1;
                    }
                    var principal = 0;
                    for (var i = 1; i <= t; i++) {
                        if(i <= year1)
                        {
                            principal = P + ( c * n2 * i );
                        }
                        
                        var    interest = 0,
                            balance = principal;
                            if (r) {
                            
                                var x = Math.pow(1 + r / n, n * i),
                                    compound_interest = P * x,
                                    contribution_interest = c * (x - 1) / (r / n2);
                                    
                                
                                interest = (compound_interest + contribution_interest - principal).toFixed(0);
                                balance = (compound_interest + contribution_interest).toFixed(0);
                            }
                            
                            if(i <= year1)
                            {
                                principal = principal - P;
                            }
                            variables.pciAmount.push(principal);
                            variables.pciInterest.push(principal + Number(interest));   
                        }    
                        if(t1 > t)
                        {
                            var years = t1 - t; 
                            var interest2 = 0;
                            interest = parseFloat(principal) + parseFloat(interest);
                            for (let i = 1; i <= years; i++) {
                                interest += interest * (r / 1);
                                variables.pciAmount.push(principal);
                                interest2 = parseFloat(interest) - parseFloat(principal);
                                variables.pciInterest.push(Number(principal+interest2).toFixed(0));
                            }  
                        }
                }
                else if(n3 == 12)
                {
                    var principal = 0;
                    var principal2 = 0;
                    var interest1 = 0;
                    for (var i = 1; i <= t; i++) {
                        if (r) {
                            
                            var months = 12;
                            var r2 = ((((1+(r))**(1/12)-1)*100) * 12) / 100;
                            for (let j = 1; j <= months; j++) {
                                principal += parseFloat(c);
                                principal += principal * (r2 / 12);
                            }
                            interest = parseFloat(principal) - parseFloat(c * (months * i));
                        }
                        
                        principal2 += parseFloat(c) * parseFloat(months);
                        variables.pciAmount.push(principal2);
                        variables.pciInterest.push(principal2+interest);    
                    }
                    if(t1 > t)
                    {
                        var years1 = t1 - t;
    
                        for (let i = 1; i <= years1; i++) {
                            principal += principal * (r / 1);
                            interest = parseFloat(principal) - parseFloat(principal2);
    
                            variables.pciAmount.push(principal2);
                            variables.pciInterest.push(principal2+interest);
                        }
                    }
                }
                else if(n3 == 2)
                {
                    var principal = 0;
                    var principal2 = 0;
                    var interest1 = 0;
                    for (var i = 1; i <= t; i++) {
                        if (r) {
                            
                            var months = 2;
                            var r2 = ((((1+(r))**(1/2)-1)*100) * 2) / 100;
                            for (let j = 1; j <= months; j++) {
                                principal += parseFloat(c);
                                    principal += parseFloat(principal) * (r2 / 2); 
                            }
                            interest = parseFloat(principal) - parseFloat(c * (months * i));
                        }
                        
                        principal2 += parseFloat(c) * parseFloat(months);
                        variables.pciAmount.push(principal2);
                        variables.pciInterest.push(principal2+interest);    
                    }
                    if(t1 > t)
                    {
                        var years1 = t1 - t;
    
                        for (let i = 1; i <= years1; i++) {
                            //principal1 += principal;
                            principal += principal * (r / 1);
                            interest = parseFloat(principal) - parseFloat(principal2);
    
                            variables.pciAmount.push(principal2);
                            variables.pciInterest.push(principal2+interest);
                        }
                    }
                }
                else if(n3 == 3)
                {
                    var principal = 0;
                    var principal2 = 0;
                    var interest1 = 0;
                    for (var i = 1; i <= t; i++) {
                        if (r) {
                            
                            var months = 4;
                            var r2 = ((((1+(r))**(1/4)-1)*100) * 4) / 100;
                            for (let j = 1; j <= months; j++) {
                                principal += parseFloat(c);
                                    principal += parseFloat(principal) * (r2 / 4);
                            }
                            interest = parseFloat(principal) - parseFloat(c * (months * i));
                        }
                        
                        principal2 += parseFloat(c) * parseFloat(months);
                        variables.pciAmount.push(principal2);
                        variables.pciInterest.push(principal2+interest);    
                    }
                    if(t1 > t)
                    {
                        var years1 = t1 - t;
    
                        for (let i = 1; i <= years1; i++) {
                            principal += principal * (r / 1);
                            interest = parseFloat(principal) - parseFloat(principal2);
    
                            variables.pciAmount.push(principal2);
                            variables.pciInterest.push(principal2+interest);
                        }
                    }
                }
    
            return {
                pciLabels:variables.pciLabels,
                pciAmount:variables.pciAmount,
                pciInterest:variables.pciInterest
            }
        },
        createChart:function (amount,interest,labels,el) { 
            const ctx = el.find('canvas').get(0).getContext('2d');
            const {variables} = powerOfCompoundInterest;
            variables.pciChartInstance && variables.pciChartInstance.destroy();
            const magnitude = Math.floor(Math.log10(variables.pciMaturity / 5));
            let stepGap;
            if (magnitude >= 2 && magnitude < 3) {
                stepGap = 100;          // 100 to 999
            } else if (magnitude >= 3 && magnitude < 4) {
                stepGap = 1000;         // 1,000 to 9,999
            } else if (magnitude >= 4 && magnitude < 5) {
                stepGap = 10000; // 10,000 to 99,999
            } else if (magnitude >= 5 && magnitude < 6) {
                stepGap = 100000;          // 100,000 to 999,999
            } else if (magnitude >= 6 && magnitude < 7) {
                stepGap = 1000000;      // 1,000,000 to 9,999,999
            } else if (magnitude >= 7 && magnitude < 8) {
                stepGap = 10000000;  // 10,000,000 to 99,999,999
            } else if (magnitude >= 8 && magnitude < 9) {
                stepGap = 100000000;          // 100,000,000 to 999,999,999
            } else {
                stepGap = undefined;      // 1,000,000,000 and above
            }
            const stepSize = ppfCalculator.methods.roundUpToNearestCeiling(variables.pciMaturity / 4, stepGap); 
            variables.pciChartInstance=new Chart(ctx,{
                type:'line',
                data:{
                    labels:labels,
                    datasets:[
                        {
                            label:'When not Invested',
                            data:amount,
                            fill:true,
                            backgroundColor:(context) => {
                                if(!context.chart.chartArea) {
                                    // Return a default color or null if chartArea is not defined yet
                                    return "rgba(239, 172, 0, 1)";
                                }
                                const{ ctx,chartArea: { top, bottom }, } = context.chart;
                                const bgColor = ["rgba(239, 172, 0, 1)","rgba(252, 246, 236, 0.5)"];
                                const gradientBg = ctx.createLinearGradient(0, top, 0, bottom); gradientBg.addColorStop(0.1, bgColor[0]); gradientBg.addColorStop(1, bgColor[1]);
                                return gradientBg;
                            },
                            borderWidth: 1,
                            pointBackgroundColor:"#ffffff",
                            pointBorderColor:"rgba(239, 172, 0, 1)",
                            pointBorderWidth:3,
                            borderColor: "rgba(239, 172, 0, 1)",
                            radius: 5,
                            tension: 0.3,
                            datalabels: {
                                color: "rgba(239, 172, 0, 1)",
                                anchor: (context) => context.dataIndex === 1 ? 'center' : 'top',
                                align: (context) => context.dataIndex === 1 ? 'left' : 'bottom',
                                clamp: false,
                                offset:8,
                                opacity:1,
                                font: {
                                    size: variables.FONT_SIZE,
                                    weight: 'lighter'
                                },
                                formatter: (value, context) =>  {
                                    const newValue = ppfCalculator.methods.formatNumber(Math.trunc(value));
                                    return context.dataIndex === context.dataset.data.length - 1 ? newValue + '    ' : newValue;
                                },
                              },
                        },
                        {
                            label:"When Invested",
                            data:interest,
                            fill:true,
                            order:1,
                            backgroundColor:(context) => {
                                if(!context.chart.chartArea) {
                                    // Return a default color or null if chartArea is not defined yet
                                    return "rgba(127, 86, 217, 1)";
                                }
                                const{ ctx,chartArea: { top, bottom }, } = context.chart;
                                const bgColor = ["rgba(127, 86, 217, 1)","rgba(252, 250, 255, 0.5)"];
                                const gradientBg = ctx.createLinearGradient(0, top, 0, bottom); gradientBg.addColorStop(0.1, bgColor[0]); gradientBg.addColorStop(1, bgColor[1]);
                                return gradientBg;
                            },
                            borderWidth: 1,
                            pointBorderColor:"rgba(127, 86, 217, 1)",
                            pointBackgroundColor:"#ffffff",
                            pointBorderWidth:3,
                            borderColor: "rgba(127, 86, 217, 1)",
                            radius: 5,
                            tension: 0.3,
                            datalabels: {
                                color: "rgba(127, 86, 217, 1)",
                                anchor: 'bottom',
                                align:"top",
                                clamp: false,
                                offset:6,
                                opacity:1,
                                font: {
                                    size: variables.FONT_SIZE,
                                    weight: 'lighter'
                                },
                                formatter: (value, context) =>  {
                                    const newValue = ppfCalculator.methods.formatNumber(Math.trunc(value));
                                    return context.dataIndex === context.dataset.data.length - 1 ? newValue + '    ' : newValue;
                                },
                              },
                        }
                    ]
                },
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    scales: {
                        x: {
                          border: {
                            display: false
                          },
                          grid: {
                            display: false,
                            drawOnChartArea:false,
                            drawTicks: false,
                            drawBorder: false,
                          },
                          title: {
                            display: true,
                            text: 'Year of Growth',
                            color: "#7A7A7A",
                            font: {
                                size: 12,
                                family: 'Satoshi',
                                weight: "lighter"
                            },
                        },
                          ticks: {
                            color: "#0067B1",
                            font: {
                                family: "Satoshi",
                            }
                        },
                        },
                        y: {
                            grid: {
                              drawTicks: false,
                            },
                            title: {
                                display: true,
                                text:'Amount Invested',
                                color: "#7A7A7A",
                                font: {
                                    size: 12,
                                    family: 'Satoshi',
                                    weight: "lighter"
                                },
                            },
                            ticks: {
                                callback: function (value) {
                                    return value >= 1000 ? (value / 1000) + 'k  ' : value;
                                },
                                stepSize: stepSize,
                                color: "#0067B1",
                                font: {
                                    family: "Satoshi",
                                }
                            },
                          }
                    },
                    plugins:{
                        legend: {
                            display: true,
                            position: 'top',
                            align: 'start',
                            labels: {
                                padding: 15,
                                font: {
                                    size: "9rem",
                                    color: "#000000"
                                },
                                generateLabels: function (chart) {
                                    const datasets = chart.data.datasets;
                                    return datasets.map((dataset, i) => ({
                                        text: `  ${dataset.label}`,
                                        fillStyle: 'transparent',
                                        strokeStyle: dataset.pointBorderColor,
                                        hidden: !chart.isDatasetVisible(i),
                                        lineWidth: 4,
                                        datasetIndex: i,
                                    }));
                                },
                                usePointStyle: true,
                                textDecoration: (ctx) => ctx.hidden ? 'line-through' : ''
                            },
                        },
                    }
                },
                plugins:[ChartDataLabels,paddingLeftPlugin],
            })
        },
          requiredValidationOnInput:function(el){
            const $el = $(el);
            const {powerOfCompoundInterestRequiredInput,powerOfCompoundInterestMobileInput,powerOfCompoundInterestNameInput} = powerOfCompoundInterest.variables;
            $el.find(powerOfCompoundInterestMobileInput).find('input').on(CONSTANT.eventsListners.INPUT,function(e){
                const mobileValue = e.target.value;
                if (mobileValue.length > 0 && (!/^[6-9][0-9]*$/.test(mobileValue))) {
                    e.target.value = mobileValue.slice(0, -1);
                }
            })
          },
          validateLengthOnInput:function(el){
            const $el = $(el);
            const { powerOfCompoundInterestInputMinLengthAttr,powerOfCompoundInterestInputMaxLengthAttr } = powerOfCompoundInterest.variables; 
            $el.find(`[${powerOfCompoundInterestInputMinLengthAttr}]`,`[${powerOfCompoundInterestInputMaxLengthAttr}]`).on(CONSTANT.eventsListners.INPUT,function(e){
                calculators.methods.validateLength();
            });
          },
          nextPrevHandler:function (el) {
            const $el = $(el);
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $self = this;
            const { variables } = powerOfCompoundInterest;
            const {powerOfCompoundInterestNextCTA,powerOfCompoundInterestPrevCTA,powerOfCompoundInterestSubmit} = variables;
            $el.find(powerOfCompoundInterestSubmit).on(CONSTANT.eventsListners.SUBMIT,function(e){
                e.preventDefault();
                calculators.methods.validateRequiredFields($el);
                calculators.methods.validateLength($el);
                const isError= $el.find('.error__active');
                if(isError.length) {return;}
                const isBack = calculators.methods.handleNextPrev(el,false);
                if(isBack){
                    $el.find(powerOfCompoundInterestPrevCTA).removeClass('d-none');
                }
                else{
                    $el.find(powerOfCompoundInterestPrevCTA).addClass('d-none');
                    $el.find(powerOfCompoundInterestNextCTA).addClass('d-none');
                    const form = $(this).get(0);
                    const pciFormData = new FormData(form);
                    const formData = Array.from(pciFormData.entries()).map(([key,value])=>({[key]:value}));
                    const combinedObj = Object.assign({}, ...formData);
                    variables.pciData.length > 0 && variables.pciData.splice(0, variables.pciData.length);
                    variables.pciData.push(combinedObj);
                    const [data] = variables.pciData;
                    const {
                        'amount':amount,
                        'duration':duration,
                        'invest':invest,
                        'invested':invested,
                        'name':name,
                        'mobile':mobile,
                        'roi':roi
                    } = data;
                    const amountInNumber = ppfCalculator.methods.removeCommas(amount);
                    variables.pciMaturity=$self.calculatePCI(amountInNumber,duration,roi,invest,invested);
                    const graphData = $self.getChartData(amountInNumber,duration,roi,invest,invested);
                    const {pciAmount,pciInterest,pciLabels} = graphData;
                    const newPciAmount = calculators.methods.calculateGapArray(pciAmount,5);
                    newPciAmount.unshift(null);
                    const newPciInterest = calculators.methods.calculateGapArray(pciInterest,5);
                    newPciInterest.unshift(null);
                    const newPciLabels = calculators.methods.calculateGapArray(pciLabels,5);
                    newPciLabels.unshift(null);
                    $self.createChart(newPciAmount,newPciInterest,newPciLabels,$el);
                    $self.setName(el);
                    $self.setAmountDuration(el);
                    $self.setMaturity(el);
                }
            });
            /* eslint-disable @typescript-eslint/no-this-alias */
            $el.find(powerOfCompoundInterestPrevCTA).on(CONSTANT.eventsListners.CLICK,function(){
                const isBack = calculators.methods.handleNextPrev(el,true);
                if(isBack){
                    $el.find(powerOfCompoundInterestPrevCTA).removeClass('d-none');
                }
                else{
                    $el.find(powerOfCompoundInterestPrevCTA).addClass('d-none');
                }
            });
          },
          setName:function(el){
            const $el = $(el);
            const { variables } = powerOfCompoundInterest;
            const {powerOfCompoundInterestNameMsgPlaceholder,powerOfCompoundInterestNameMsg} = variables;
            const nameText = $el.find(powerOfCompoundInterestNameMsg);
            const namePlaceholder = powerOfCompoundInterestNameMsgPlaceholder;
            const replaceText = 'Hi {name}, your investment';
            if(nameText.length > 0){
                const userName = replaceText.replace(namePlaceholder, `<span class="text-blue-400 fw-bold">${variables.pciData[0].name.split(' ')[0]}</span>`);
                nameText.html(userName);
            }
        },
        setAmountDuration:function(el){
            const $el = $(el);
            const { variables } = powerOfCompoundInterest;
            const { powerOfCompoundInterestSubheading,powerOfCompoundInterestTotalYearsPlaceholder,powerOfCompoundInterestRoiPlaceholder } = variables;
            const subheadingText = $el.find(powerOfCompoundInterestSubheading).removeClass('d-none');
            const maxYears = Math.max(variables.pciData[0].invest,variables.pciData[0].invested);
            const roi = variables.pciData[0].roi;
            const subheadingReplaceText=' after {years} at {roi}';
            if(subheadingText.length > 0){
                const subheadingFilledText = subheadingReplaceText
                .replace(powerOfCompoundInterestTotalYearsPlaceholder,`<span class="text-blue-400 fw-bold font-24 power__of__ci__maturity--years">${maxYears} years</span>`)
                .replace(powerOfCompoundInterestRoiPlaceholder,`<span class="text-blue-400 fw-bold font-24 power__of__ci__maturity--years">${roi}%</span>`);
                subheadingText.html(subheadingFilledText);
            } 
        },
        setMaturity:function(el){
            const $el = $(el);
            const { variables } = powerOfCompoundInterest;
            const { powerOfCompoundInterestMaturity, powerOfCompoundInterestSubheading} = variables;
            const maturityText = $el.find(powerOfCompoundInterestMaturity).removeClass('d-none');
            if(maturityText.length > 0){
                const maturity = variables.pciMaturity;
                if(maturity == 0){
                    maturityText.html(`<span class="text-red-300 font-12 leading-13">Seems Yours Goal is already achieved basis inputs provided. Please recalculate if needed!</span>`);
                    $el.find(powerOfCompoundInterestSubheading).addClass('opacity-0');
                }else{
                    maturityText.html(``);
                    maturityText.text(`₹ ${ppfCalculator.methods.formatNumber(maturity)}`);
                    $el.find(powerOfCompoundInterestSubheading).removeClass('opacity-0');
                }
            }
        },
        reCalculate:function(el){
            const $el = $(el);
            const { variables:{powerOfCompoundInterestReCalculateBtn,powerOfCompoundInterestNextCTA} } = powerOfCompoundInterest;
            $el.find(powerOfCompoundInterestReCalculateBtn).on(CONSTANT.eventsListners.CLICK,function(){
                $('[data-page]').removeClass('active');
                $el.find('[data-page="1"]').addClass('active');
                $el.find(powerOfCompoundInterestNextCTA).removeClass('d-none');
            })
        },
        setChartFontSize:function(){
            const { variables } = powerOfCompoundInterest;
            if(window.matchMedia("(max-width:768px)").matches) {
                variables.FONT_SIZE = 10;
            }
            else if(window.matchMedia("(max-width:540px)").matches){
                variables.FONT_SIZE = 6;
            }
            else{
                variables.FONT_SIZE = 12;
            }
        },
        dataLayerObj: function (e, name, section) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                'pageSection' : name.replace(/\n/g, '').trim().concat('_').concat(section).replace(/\n/g, '').trim(),
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                'name': powerOfCompoundInterest.variables.userName ? powerOfCompoundInterest.variables.userName : "",
                'mobileNumber': powerOfCompoundInterest.variables.mobileNo ? powerOfCompoundInterest.variables.mobileNo : "",
                "countryCode" : "+91",
            };
            return obj;
        },
          init:function(){
            this.initializePCI();
            $('.power__of__ci__cta--next').on('click', function(e){
                      let calculatorSection=$(this).closest('.powerOfCompounding').find('.chli__calculator__step--label.active').text();
                      let calculatorName=$(this).closest('.powerOfCompounding').find('.power__of__ci--heading ').text();

                       let activeClass = $(this).closest('.power__of__ci--form');
                       let activeClassElement = activeClass.find('.power__of__ci--page.active');

                           // Check if the active page is 3
                           let containerNumber = activeClassElement.data('page');
                           if (containerNumber === 3) {
                               // Store the name and mobile number in the variables
                               powerOfCompoundInterest.variables.userName = activeClassElement.find('.power__of__ci__name--text .power__of__ci--input').val();
                               powerOfCompoundInterest.variables.mobileNo = activeClassElement.find('.power__of__ci__mobile--text .power__of__ci--input').val();
                           }

                        var obj = powerOfCompoundInterest.methods.dataLayerObj(e,calculatorName,calculatorSection);
                        createDataLayer('buttonClick', obj);
                        });

            $('.power__of__ci__cta--back').on('click', function(e){
               
                let calculatorSection=$(this).closest('.powerOfCompounding').find('.chli__calculator__step--label.active').text();
                let calculatorName=$(this).closest('.powerOfCompounding').find('.power__of__ci--heading ').text();

            var obj = powerOfCompoundInterest.methods.dataLayerObj(e,calculatorName,calculatorSection);
            createDataLayer('buttonClick', obj);
            });
            $('.power__of__ci--resettext').on('click', function(e){
                
                let calculatorSection=$(this).closest('.powerOfCompounding').find('.chli__calculator__step--label.active').text();
                let calculatorName=$(this).closest('.powerOfCompounding').find('.power__of__ci--heading ').text();

            var obj = powerOfCompoundInterest.methods.dataLayerObj(e,calculatorName,calculatorSection);
            createDataLayer('buttonClick', obj);
            });
            $('.power__of__ci--viewall').on('click', function(e){
                
                let calculatorSection=$(this).closest('.powerOfCompounding').find('.chli__calculator__step--label.active').text();
                let calculatorName=$(this).closest('.powerOfCompounding').find('.power__of__ci--heading ').text();

            var obj = powerOfCompoundInterest.methods.dataLayerObj(e,calculatorName,calculatorSection);
            createDataLayer('buttonClick', obj);
            });
            
            $('.power__of__ci__freq--wrapper').on('click', function(e){  
            let calculatorSection=$(this).closest('.powerOfCompounding').find('.chli__calculator__step--label.active').text();
            let calculatorName=$(this).closest('.powerOfCompounding').find('.power__of__ci--heading ').text();
            var obj = powerOfCompoundInterest.methods.dataLayerObj(e,calculatorName,calculatorSection);
            createDataLayer('buttonClick', obj);
            });
          }
    }
};

$(()=>{
    if(powerOfCompoundInterest.variables.powerOfCompoundInterestWrapper.length){
    powerOfCompoundInterest.methods.init();
    }
})